import { render } from "./App.vue?vue&type=template&id=092c86b0"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=092c86b0&lang=css"

import exportComponent from "/home/runner/work/motokandemir-web/motokandemir-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__